import * as JSZip from 'jszip';

import { Report } from "./Reports/Report.js";

import { BlobNode } from "./Nodes/BlobNode.js";

/* ==----------------------------------------------------------------------------------------------------------== */
/* ==-----------------------------------------== Global functions ==-------------------------------------------== */
/* ==----------------------------------------------------------------------------------------------------------== */

/**
 * @description Resolves any conflicting file names by adding a (n) behind the name
 * @param { [FileNode] } files
 */
function resolveFileNameConflicts(files) {
    let hasConflicts = true;

    while (hasConflicts) {
        hasConflicts = false;

        for (let i = 0; i < files.length; i++) {
            let baseFile = files[i];
            let counter = 2;

            for (let j = i + 1; j < files.length; j++) {
                let file = files[j];

                if (baseFile.name === file.name) {
                    hasConflicts = true;

                    let extensionPosition = file.name.lastIndexOf(".");

                    let newName = [
                        file.name.slice(0, extensionPosition),
                        " (" + counter + ")",
                        file.name.slice(extensionPosition)
                    ].join("");

                    file.name = newName;

                    counter++;
                }
            }
        }
    }
}

/**
 * @description Creates a FileNode representing a .zip file, or just a file if the list has only one FileNode
 * @param { String } name The name of the resulting archive
 * @param { [FileNode] } files The list of files to archive
 * @returns { {Report, FileNode} } A structure containing a report indicating the exit status, and the resulting FileNode
 */
export async function generateZipFrom(name, files) {
    /* No need to archive if only one file is present */
    if (files.length === 1) {
        return Report.data(files[0]);
    }

    let zip = new JSZip();

    resolveFileNameConflicts(files);

    for (let i = 0; i < files.length; i++) {
        let file = files[i];

        /* Only add if the file has content */
        if (file.hasContent()) {
            let blob = file.getContentAsBlob();

            if (blob !== null) {
                zip.file(file.name, blob);
            } else {
                console.log("File " + file.name + " produced an invalid blob");

                return Report.ko();
            }
        } else {
            console.log("File " + file.name + " has no content to archive");

            return Report.ko();
        }
    }

    /* Zip generation */
    return zip.generateAsync({ type: "blob" })
        .then(blob => {
            let zipFileNode = new BlobNode(name, blob);

            return Report.data(zipFileNode);
        })
        .catch(error => {
            console.log(error);

            return Report.ko();
        });
}
